const bwipjs = require('bwip-js');


export default {
  async invoice(invoice, receiptBusiness, settings) {

    const content = [];
    let itemCount = 0;

    const testCont = []
    let totalPrice = 0
    let total = 0

    const processDetail = async (detail) => {
      totalPrice += parseFloat(detail.price)
      total += parseFloat(detail.price*detail.qty)
      itemCount += parseFloat(detail.qty)

      const productName = detail.name
      const columns = [
        {
          text: detail.id,
          alignment: 'left',
        }
      ];

      columns.push({
        text: productName,
        alignment: 'left',
      })

      columns.push({
        text: `${parseFloat(detail.qty)}`,
        alignment: 'right',
      })

      columns.push({
          text: `${settings.options.filters.currency(detail.price)}`,
          alignment: 'right',
        });

      columns.push({
        text: `${settings.options.filters.currency(
          detail.price * detail.qty)}`,
        alignment: 'right',
      });

      testCont.push(columns)
    };


    await invoice.InvoiceDetails.reduce(async (prev, curr) => {
      await prev;
      return processDetail(curr);
    }, Promise.resolve());



    console.log('testCont', testCont)
    content.push(
      {
        layout: {
            fillColor: function (rowIndex, node, columnIndex) {
                return (rowIndex % 2 === 0) ? '#E0E0E0' : null;
            },
            hLineWidth: function (i, node) {
                return (i === 0 || i === node.table.body.length) ? 1 : 0;
            },
        },
        table: {
          widths: [75, '*', 75, 75, 75],
          body: [
            [{ text: 'ID', alignment: 'center', bold: true }, { text: 'Description', bold: true },{ text: 'QTY', alignment: 'center', bold: true }, { text: 'Price', bold: true }, { text: 'Total', alignment: 'center', bold: true }],
            ...testCont,
          ],
        },
      },
    )

    content.push(
      {
        layout: {
          hLineWidth: function (i, node) {
            return (i === 0) ? 0 : 1;
          },
        },
        table: {
          widths: [75, '*', 75, 75, 75],
          body: [
            ['', { text: 'Total', bold: true }, { text: itemCount, alignment: 'right' },{ text: `${settings.options.filters.currency(totalPrice)}`, alignment: 'right' }, { text: `${settings.options.filters.currency(total)}`, alignment: 'right' }],
          ],
        },
      },
    )

    return content;
  },

  async invoiceHeader(invoice, receiptBusiness, settings){
    const canvas = document.createElement('canvas');

    const barcode = await new Promise((resolve, reject) => {
      bwipjs(
        canvas,
        {
          bcid: 'code128', // Barcode type
          text: invoice.localId.toString(), // Text to encode
          scale: 3, // 3x scaling factor
          height: 3, // Bar height, in millimeters
          includetext: false, // Show human-readable text
          textxalign: 'center', // Always good to set this
        },
        async (err, cvs) => {
          if (err) {
            // Decide how to handle the error
            // `err` may be a string or Error object
            reject(err);
          } else {
            resolve(canvas.toDataURL('image/png'));
          }
        },
      );
    });
    let base64 = null
    if (receiptBusiness.imageUrl) {
      try {
        const toDataURL = (url) =>
          fetch(url, { mode: 'cors' })
            .then((response) => response.blob())
            .then(
              (blob) =>
                new Promise((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onloadend = () => resolve(reader.result);
                  reader.onerror = reject;
                  reader.readAsDataURL(blob);
                }),
            );

        base64 = await toDataURL(receiptBusiness.imageUrl).then(
          (dataUrl) => dataUrl,
        );
      } catch (error) {
        console.log('image through error', error);
      }
    }
    let imageColumn = null
    if(base64){
      imageColumn = {
        image: base64,
        width: 130,
        height: 63,
        alignment: 'right',
      }
    }
    const header = {
      stack: [
        {
          alignment: 'left',
          margin: 8,
          columnGap: 10,
          columns: [
            {
              width: '*',
              stack: [
                { text: settings.capitalize(receiptBusiness.name), style: 'header'},
                { text: `${receiptBusiness.address1} ${receiptBusiness.city}, ${receiptBusiness.state} ${receiptBusiness.zip}`, 
                  style: 'invoiceAddress' },
                { text: settings.formatPhoneNumber(receiptBusiness.phoneNumber), style: 'invoiceAddress' },
                { text: receiptBusiness.email, style: 'invoiceAddress' }
              ]
            },
            imageColumn,
          ],
        },
        {text: 'INVOICE', style: 'header', margin: [9,0,0,0]},
        {
          alignment: 'left',
          margin: [12, 6, 8, 0],
          columnGap: 10,
          columns: [
            {
                style: 'tableExample',
                width: 170,
                table: {
                    headerRows: 1,
                    widths: [160],
                    body: [
                        [{text: 'Bill To ', style: 'tableHeader'}],
                        [
                            {
                                text:`${invoice.Customer ? settings.capitalize(invoice.Customer.name) : 'Walk-In Customer'}
                                    ${invoice.Customer ? invoice.Customer.address ? invoice.Customer.address : 'N/A' : 'N/A'}
                                    ${invoice.Customer ? settings.formatPhoneNumber(invoice.Customer.phoneNumber) : '---'}
                                    ${invoice.Customer ? invoice.Customer.email : '---'}`,
                                style: 'invoiceAddress'
                            }
                        ]
                    ]
                }
            },
            {
                style: 'tableExample',
                width: 246,
                table: {
                    headerRows: 1,
                    widths: [160],
                    body: [
                        [{text: 'Shipping To ', style: 'tableHeader'}],
                        [
                            {
                                text:`${invoice.Customer ? settings.capitalize(invoice.Customer.name) : 'Walk-In Customer'}
                                    ${invoice.Customer ? invoice.Customer.shippingAddress ? invoice.Customer.shippingAddress : 'N/A' : 'N/A'}
                                    ${invoice.Customer ? settings.formatPhoneNumber(invoice.Customer.phoneNumber) : '---'}
                                    ${invoice.Customer ? invoice.Customer.email : '---'}`,
                                style: 'invoiceAddress'
                            }
                        ]
                    ]
                }
            },
            {
              alignment: 'right',
              width: 'auto',
              stack: [
                { image: barcode, width: 120, alignment: 'right', margin: [0, 0, 3, 9]},
                {
                  table: {
                      headerRows: 1,
                      body: [
                          [{text: 'Date', style: 'tableHeader',alignment: 'left'}, {text: settings.date, style: 'invoiceAddress', alignment: 'right'}],
                          [{text: 'Invoice #', style: 'tableHeader', alignment: 'left'}, {text: invoice.localId, style: 'invoiceAddress', alignment: 'right'}],
                      ]
                  }
                },
              ]
            },
          ],
        },
      ]
    };
    return header;
  },

  async invoiceFooter(invoice, receiptBusiness, settings){
    const canvas = document.createElement('canvas');

    const qrbarcode = await new Promise((resolve, reject) => {
      bwipjs(
        canvas,
        {
          bcid: 'qrcode', // Barcode type
          text: invoice.id.toString(), // Text to encode
        },
        (err, cvs) => {
          if (err) {
            // Decide how to handle the error
            // `err` may be a string or Error object
            reject(err);
          } else {
            resolve(canvas.toDataURL('image/png'));
          }
        },
      );
    });
    pdfMake.tableLayouts = {
      myCustomLayout: {
        hLineWidth: function (i, node) {
          return (i === 0) ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? 1 : 0;
        },
      }
    };
    const footer = function(currentPage, pageCount){
      return[
        {
          stack: [
            {canvas: [{ type: 'line', x1: 12, y1: 10, x2: 598, y2: 10, lineWidth: 1 }]},
            {
              columns: [
                { 
                  width: settings.width * 0.2,
                  margin: [10, 10, 10, 10],
                  alignment: 'left',
                  image: qrbarcode,
                },
                { width: 100, text: 'Order Again', margin: [17, 10, 10, 10], },
                { width: 287, text: '' },
                {
                  width: 'auto',
                  layout: 'myCustomLayout',
                  table: {
                      widths: [76,75],
                      body: [
                          [{text: 'Subtotal', style:'subheader'}, {text: settings.options.filters.currency(invoice.total), alignment: 'right', margin: [0, 3, 0, 5]}],
                          [{text: 'Total Paid', style:'subheader'}, {text: settings.options.filters.currency(invoice.payment), alignment: 'right',margin: [0, 3, 0, 5]}],
                          [{text: 'Invoice Due', style:'subheader'}, {text: settings.options.filters.currency(invoice.due), alignment: 'right', margin: [0, 3, 0, 5]}],
                      ]
                  }
                },
              ],
            },
            {
              text: receiptBusiness.policy,
              margin: [10, 3, 10, 3],
              style: 'policy',
              small: true,
            },
            {
              text: `${currentPage.toString()} of ${pageCount}`, alignment: 'center' 
            }
          ]
        }
      ]
    }

    return footer
  }
}
